import { jsx } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { forwardRef } from "react";
import { useSlotProps } from "../../../base/index.js";
import { useToolbar } from "../hooks/useToolbar.js";
import { toolbarBrandingName } from "./classes.js";
import { Root } from "./components/Root.js";
import { useUtilityClasses } from "./hooks/useUtilityClasses.js";
const ToolbarBranding = forwardRef(function ToolbarBranding2(inProps, ref) {
  const props = useThemeProps({
    name: toolbarBrandingName,
    props: inProps
  });
  const { children, className = "", components, componentsProps, sx, testId = `${toolbarBrandingName}-root` } = props;
  const ownerState = props;
  const utilityClasses = useUtilityClasses(ownerState);
  const { cssVariables } = useToolbar();
  const rootSlotProps = useSlotProps({
    className: `${className} ${utilityClasses.root}`,
    elementType: Root,
    externalSlotProps: componentsProps?.root,
    ownerState,
    additionalProps: {
      "data-testid": testId,
      "data-tidal": toolbarBrandingName,
      as: components?.Root,
      cssVariables,
      ref,
      sx
    }
  });
  return /* @__PURE__ */ jsx(Root, { ...rootSlotProps, children });
});
export {
  ToolbarBranding
};
//# sourceMappingURL=ToolbarBranding.js.map
